<template>
  <a-modal
    :visible="visible"
    :title="dialogTitle"
    :width="'46.875%'"
    :footer="null"
    :destroy-on-close="true"
    :centered="true"
    :z-index="99999999"
    :get-container="getContainer"
    wrap-class-name="hik-video-modal-wrap"
    @cancel="close"
  >
    <div class="video-test-container">
      <div v-if="refreshing || countdownExpired" class="full-overlay" @click="refreshLiveList">
        <a-icon
          :type="refreshing ? 'loading' : 'reload'"
          :spin="refreshing"
          style="font-size: 78px; color: #1890ff"
        />
        <span class="full-overlay-text">
          {{ refreshing ? '重新推流中...' : '直播已过期，点击重新推流' }}
        </span>
      </div>
      <div class="live-list">
        <div class="live-list-header">
          <span>直播列表1</span>
          <div class="header-right">
            <span v-if="countdownText" class="countdown" :class="{ expired: countdownExpired }">
              {{ countdownText }}
            </span>
            <span
              class="refresh-btn"
              :class="{ expired: countdownExpired, refreshing: refreshing }"
              @click="refreshLiveList"
              >重新推流</span
            >
          </div>
        </div>
        <div class="live-list-body">
          <div
            v-for="(item, index) in liveList"
            :key="index"
            class="live-list-item"
            :class="{ active: activeLiveIndex === index }"
            @click="selectLive(index)"
          >
            <span class="live-dot" :class="liveStatusList[index] || 'checking'"></span>
            <span class="live-item-name">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="video-section">
        <HlsVideo
          v-if="hlsUrl"
          :src="hlsUrl"
          width="100%"
          height="100%"
          :muted="true"
          :autoplay="true"
          :controls="true"
          :retryable="true"
        />
        <div v-else class="video-placeholder">
          <a-icon type="loading" style="font-size: 78px; color: #999" />
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import HlsVideo from './HlsVideo.vue'
import axios from 'axios'
import Icon from 'ant-design-vue/lib/icon'
import { liveList as fetchLiveList } from '@/api/agriculture-dashboard'

var HLS_SERVER = process.env.VUE_APP_HLS_SERVER || 'http://localhost:8888'

export default {
  name: 'HikVideoTestDialog',
  components: {
    HlsVideo: HlsVideo,
    AIcon: Icon,
  },
  data: function() {
    return {
      visible: false,
      hlsUrl: '',
      streamId: '',
      streamRunning: false,
      pollTimer: null,
      currentRtspUrl: '',
      dialogTitle: '视频监控',
      activeLiveIndex: 0,
      liveList: [],
      liveStatusList: [],
      refreshing: false,
      // 状态检测相关
      checkTimers: {},
      // 倒计时相关
      expireRemainSeconds: 0,
      countdownTimer: null,
      countdownExpired: false,
    }
  },
  computed: {
    countdownText: function() {
      if (this.expireRemainSeconds <= 0) return ''
      var m = Math.floor(this.expireRemainSeconds / 60)
      var s = this.expireRemainSeconds % 60
      return m + ':' + (s < 10 ? '0' + s : s)
    },
  },
  methods: {
    // 挂载到缩放容器内，跟随大屏等比缩放
    getContainer: function() {
      return document.getElementById('screen-agriculture') || document.body
    },
    // 获取直播列表
    loadLiveList: function(isRefresh) {
      var self = this
      self.refreshing = true
      return fetchLiveList({ refresh: isRefresh })
        .then(function(res) {
          var data = (res && res.data) || {}
          var list = data.liveList || []
          if (Array.isArray(list)) {
            self.liveList = list.map(function(item) {
              return {
                name: item.name || '未命名',
                url: item.pullUrl || '',
                sourceUrl: item.sourceUrl || '',
                endTime: item.endTime || '',
              }
            })
          }
          self.expireRemainSeconds = data.expireRemainSeconds || 0
          self.countdownExpired = false
          self.startCountdown()
          // 用 endTime 字段回显在线状态
          var now = new Date()
          self.liveStatusList = self.liveList.map(function(item) {
            if (!item.endTime) return 'offline'
            var end = new Date(item.endTime.replace(/-/g, '/'))
            return end > now ? 'online' : 'offline'
          })
          // 检测实际在线状态
          self.checkAllStreamStatus()
        })
        .catch(function() {
          // 接口失败，静默处理
        })
        .then(function() {
          self.refreshing = false
        })
    },
    // 开始倒计时
    startCountdown: function() {
      var self = this
      if (self.countdownTimer) {
        clearInterval(self.countdownTimer)
        self.countdownTimer = null
      }
      if (self.expireRemainSeconds <= 0) {
        self.countdownExpired = true
        return
      }
      self.countdownTimer = setInterval(function() {
        self.expireRemainSeconds--
        if (self.expireRemainSeconds <= 0) {
          self.expireRemainSeconds = 0
          self.countdownExpired = true
          if (self.countdownTimer) {
            clearInterval(self.countdownTimer)
            self.countdownTimer = null
          }
        }
      }, 1000)
    },
    // 重新推流（续期 + 重启播放）
    refreshLiveList: function() {
      if (this.refreshing) return
      var self = this
      // 停止当前播放流
      if (self.pollTimer) {
        clearTimeout(self.pollTimer)
        self.pollTimer = null
      }
      self.stopStream()
      // 带 refresh=true 重新请求
      self.loadLiveList(true).then(function() {
        // 重新启动当前选中的播放流
        if (self.currentRtspUrl) {
          self.startStream()
        }
      })
    },
    show: function(rtspUrl, title) {
      var self = this
      self.currentRtspUrl = rtspUrl || ''
      self.dialogTitle = title || '视频监控'
      self.visible = true
      self.activeLiveIndex = 0
      self.liveList = []
      self.liveStatusList = []
      // 第一次打开，refresh=false 获取列表
      self.loadLiveList(false).then(function() {
        // 列表加载完成后按 sourceUrl 匹配选中项
        self.matchActiveIndex(rtspUrl)
        var matchedItem = self.liveList[self.activeLiveIndex]
        if (matchedItem) {
          self.currentRtspUrl = matchedItem.url
          self.dialogTitle = matchedItem.name || title || '视频监控'
        }
        // 启动播放
        if (self.currentRtspUrl) {
          self.startStream()
        }
      })
    },
    // 匹配选中项（按 sourceUrl 匹配）
    matchActiveIndex: function(rtspUrl) {
      var self = this
      var matchedIndex = -1
      if (rtspUrl) {
        matchedIndex = self.liveList.findIndex(function(item) {
          return item.sourceUrl === rtspUrl
        })
      }
      self.activeLiveIndex = matchedIndex !== -1 ? matchedIndex : 0
    },
    close: function() {
      var self = this
      // 清除播放轮询定时器
      if (self.pollTimer) {
        clearTimeout(self.pollTimer)
        self.pollTimer = null
      }
      // 清除倒计时定时器
      if (self.countdownTimer) {
        clearInterval(self.countdownTimer)
        self.countdownTimer = null
      }
      // 停止所有检测定时器
      self.stopCheckStream()
      // 停止播放流
      self.stopStream()
      self.visible = false
    },
    selectLive: function(index) {
      if (index === this.activeLiveIndex) return
      this.activeLiveIndex = index
      var item = this.liveList[index]
      if (!item) return
      if (this.pollTimer) {
        clearTimeout(this.pollTimer)
        this.pollTimer = null
      }
      this.stopStream()
      this.currentRtspUrl = item.url
      this.dialogTitle = item.name || '视频监控'
      this.startStream()
    },
    // 检测所有直播流状态
    checkAllStreamStatus: function() {
      var self = this
      // 清除旧定时器
      Object.keys(self.checkTimers).forEach(function(key) {
        if (self.checkTimers[key]) {
          clearTimeout(self.checkTimers[key])
          delete self.checkTimers[key]
        }
      })
      // 所有项先设为 checking
      self.liveStatusList = self.liveList.map(function() {
        return 'checking'
      })
      // 逐个检测，最多并发2个，用 pullUrl(m3u8) 检测
      var queue = self.liveList.map(function(item, index) {
        return { url: item.url, index: index }
      })
      var maxConcurrent = 2
      var running = 0
      function next() {
        if (queue.length === 0) return
        if (running >= maxConcurrent) return
        running++
        var task = queue.shift()
        self.checkStreamStatus(task.url, task.index, function() {
          running--
          next()
        })
        next()
      }
      next()
    },
    // 检测单个流状态
    checkStreamStatus: function(url, index, callback) {
      var self = this
      if (!url) {
        self.$set(self.liveStatusList, index, 'offline')
        if (callback) callback()
        return
      }
      var maxAttempts = 6
      var attempts = 0

      function check() {
        attempts++
        if (self.isM3u8(url)) {
          // m3u8 直接请求检测
          axios
            .get(url, { timeout: 3000 })
            .then(function(resp) {
              var content = (resp.data || '').toString()
              if (content.indexOf('.ts') !== -1 || content.indexOf('#EXTINF') !== -1) {
                self.$set(self.liveStatusList, index, 'online')
                if (callback) callback()
              } else if (attempts < maxAttempts) {
                self.checkTimers[index] = setTimeout(check, 500)
              } else {
                self.$set(self.liveStatusList, index, 'offline')
                if (callback) callback()
              }
            })
            .catch(function() {
              if (attempts < maxAttempts) {
                self.checkTimers[index] = setTimeout(check, 500)
              } else {
                self.$set(self.liveStatusList, index, 'offline')
                if (callback) callback()
              }
            })
        } else {
          // RTSP 通过 HLS 服务器检测
          axios
            .post(HLS_SERVER + '/api/stream/start', { rtspUrl: url })
            .then(function(res) {
              var streamId = res.data.streamId
              var hlsUrl = res.data.hlsUrl
              var pollAttempts = 0
              function poll() {
                pollAttempts++
                axios
                  .get(hlsUrl, { timeout: 3000 })
                  .then(function(resp) {
                    var content = (resp.data || '').toString()
                    if (content.indexOf('.ts') !== -1) {
                      self.$set(self.liveStatusList, index, 'online')
                      // 停止检测流
                      axios.post(HLS_SERVER + '/api/stream/stop', { streamId: streamId })
                      if (callback) callback()
                    } else if (pollAttempts < 8) {
                      self.checkTimers[index] = setTimeout(poll, 500)
                    } else {
                      self.$set(self.liveStatusList, index, 'offline')
                      axios.post(HLS_SERVER + '/api/stream/stop', { streamId: streamId })
                      if (callback) callback()
                    }
                  })
                  .catch(function() {
                    if (pollAttempts < 8) {
                      self.checkTimers[index] = setTimeout(poll, 500)
                    } else {
                      self.$set(self.liveStatusList, index, 'offline')
                      axios.post(HLS_SERVER + '/api/stream/stop', { streamId: streamId })
                      if (callback) callback()
                    }
                  })
              }
              self.checkTimers[index] = setTimeout(poll, 1500)
            })
            .catch(function() {
              self.$set(self.liveStatusList, index, 'offline')
              if (callback) callback()
            })
        }
      }
      check()
    },
    // 停止所有检测定时器
    stopCheckStream: function() {
      var self = this
      Object.keys(self.checkTimers).forEach(function(key) {
        if (self.checkTimers[key]) {
          clearTimeout(self.checkTimers[key])
          delete self.checkTimers[key]
        }
      })
    },
    isM3u8: function(url) {
      return url && url.indexOf('.m3u8') !== -1
    },
    startStream: function() {
      var self = this
      if (!self.currentRtspUrl) return
      self.hlsUrl = ''
      if (self.pollTimer) {
        clearTimeout(self.pollTimer)
        self.pollTimer = null
      }

      // m3u8 直连，跳过 HLS 服务器转码
      if (self.isM3u8(self.currentRtspUrl)) {
        self.streamId = ''
        self.streamRunning = false
        self.hlsUrl = self.currentRtspUrl
        return
      }

      axios
        .post(HLS_SERVER + '/api/stream/start', { rtspUrl: self.currentRtspUrl })
        .then(function(res) {
          var data = res.data
          self.streamId = data.streamId
          self.streamRunning = true

          var targetUrl = data.hlsUrl
          var pollAttempts = 0
          var maxPollAttempts = 40

          function checkStreamReady(callback) {
            axios
              .get(targetUrl, { timeout: 3000 })
              .then(function(resp) {
                var content = resp.data || ''
                var hasSegments = content.indexOf('.ts') !== -1
                callback(hasSegments)
              })
              .catch(function() {
                callback(false)
              })
          }

          function pollM3u8() {
            pollAttempts++
            checkStreamReady(function(ready) {
              if (ready) {
                self.pollTimer = setTimeout(function() {
                  self.hlsUrl = targetUrl
                }, 2000)
              } else if (pollAttempts < maxPollAttempts && self.streamRunning) {
                self.pollTimer = setTimeout(pollM3u8, 500)
              } else {
                self.hlsUrl = targetUrl
              }
            })
          }

          self.pollTimer = setTimeout(pollM3u8, 1500)
        })
        .catch(function() {})
    },
    stopStream: function() {
      var self = this
      if (!self.streamId) return
      axios
        .post(HLS_SERVER + '/api/stream/stop', { streamId: self.streamId })
        .then(function() {
          self.hlsUrl = ''
          self.streamId = ''
          self.streamRunning = false
        })
        .catch(function() {
          self.hlsUrl = ''
          self.streamId = ''
          self.streamRunning = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.video-test-container {
  display: flex;
  position: relative;

  .full-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 20;
    cursor: pointer;

    .full-overlay-text {
      color: #1890ff;
      font-size: 34px;
      margin-top: 21px;
    }
  }

  .live-list {
    width: 430px;
    flex-shrink: 0;
    background: #1a1a2e;
    border-radius: 9px;
    margin-right: 26px;
    display: flex;
    flex-direction: column;
    max-height: 1120px;

    .live-list-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 26px 34px;
      font-size: 34px;
      font-weight: bold;
      color: #fff;
      border-bottom: 1px solid #2a2a4a;
      flex-shrink: 0;

      .header-right {
        display: flex;
        align-items: center;
      }

      .countdown {
        font-size: 26px;
        color: #4caf50;
        margin-right: 17px;
        font-weight: normal;
        font-family: monospace;

        &.expired {
          color: #ff4d4f;
        }
      }

      .refresh-btn {
        cursor: pointer;
        color: #1890ff;
        font-size: 26px;
        font-weight: normal;
        transition: color 0.2s;
        white-space: nowrap;

        &:hover {
          color: #40a9ff;
        }

        &.refreshing {
          opacity: 0.6;
          pointer-events: none;
        }

        &.expired {
          color: #ff4d4f;
          animation: live-blink 1s infinite;
        }
      }
    }

    .live-list-body {
      flex: 1;
      overflow-y: auto;
      padding: 17px;

      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-thumb {
        background: #444;
        border-radius: 4px;
      }
    }

    .live-list-item {
      display: flex;
      align-items: center;
      padding: 30px 26px;
      border-radius: 13px;
      cursor: pointer;
      transition: background 0.2s;
      margin-bottom: 9px;

      &:hover {
        background: rgba(255, 255, 255, 0.08);
      }

      &.active {
        background: rgba(13, 107, 207, 0.3);
        border: 1px solid #0d6bcf;
      }

      .live-dot {
        width: 17px;
        height: 17px;
        border-radius: 50%;
        flex-shrink: 0;
        margin-right: 17px;

        &.checking {
          background: #ffc300;
          animation: live-blink 1.5s infinite;
        }

        &.online {
          background: #4caf50;
          animation: live-blink 1.5s infinite;
        }

        &.offline {
          background: #666;
        }
      }

      @keyframes live-blink {
        0%,
        100% {
          opacity: 1;
        }
        50% {
          opacity: 0.3;
        }
      }

      .live-item-name {
        font-size: 30px;
        color: #ccc;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
      }

      &.active .live-item-name {
        color: #fff;
      }
    }
  }

  .video-section {
    flex: 1;
    background: #000;
    border-radius: 9px;
    overflow: hidden;
    min-width: 0;
    position: relative;
    aspect-ratio: 4 / 3.275;
  }

  .video-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #888;
  }
}
</style>

<style lang="scss">
// 弹窗挂载在 4096 设计稿缩放容器内，ant-modal 内部元素按设计稿尺寸放大
.hik-video-modal-wrap {
  .ant-modal {
    border-radius: 9px;
  }

  .ant-modal-header {
    padding: 30px 76px 30px 48px;
    border-bottom: 1px solid #e8e8e8;
    border-radius: 9px 9px 0 0;
  }

  .ant-modal-title {
    font-size: 36px;
    line-height: 1.4;
  }

  .ant-modal-close {
    right: 24px;
    width: 46px;
    height: 46px;
    line-height: 76px;

    .ant-modal-close-x {
      width: 46px;
      height: 46px;
      font-size: 32px;
      line-height: 76px;
    }
  }

  .ant-modal-body {
    padding: 48px;
  }
}
</style>
